import { IconQWEP } from '@f_components/icons/IconQwep';
import { ThemeContext } from '@f_context/Theme_context';
import stls from '@f_styles/components/auth/Authorization.module.sass';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Box } from '@mui/system';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Registration } from './Registration';

export function VisibleRegistration({ alignment, setAlignment }) {
    const { t } = useTranslation();
    const { colors, currentTheme } = useContext(ThemeContext);

    return (
        <Box className={stls.container}>
            <div className={stls.IconQwep}>
                {currentTheme == 'vinpin' ? null : (
                    // <IconVinPin width={'287'} height={'78'} />
                    <IconQWEP width={'287'} height={'78px'} />
                )}
                <div style={{ color: colors.omicron }} className={stls.text}>
                    Цифровой комплекс продуктов для автоматизации и принятия управленческих решений
                </div>
            </div>
            <ToggleButtonGroup
                onChange={() => {}}
                value={alignment}
                exclusive
                color="primary"
                className={stls.toggleGroup}>
                <ToggleButton className={stls.toggle} value="registr">
                    {t('auth.sidebar.registration')}
                </ToggleButton>
            </ToggleButtonGroup>
            <Registration setAlignment={setAlignment} />
        </Box>
    );
}
